import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[twoDecimals]'
})
export class TwoDecimalsDirective {
  private regExp: RegExp = new RegExp(/^[0-9]+[,\.]?[0-9]{0,2}$/g);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete'
  ];

  constructor(private element: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const currentValue: string = this.element.nativeElement.value;
    const charPosition = this.element.nativeElement.selectionStart;
    const nextValue: string = [
      currentValue.slice(0, charPosition),
      event.key === 'Decimal' ? ',' : event.key,
      currentValue.slice(charPosition)
    ].join('');
    if (nextValue && !String(nextValue).match(this.regExp)) {
      event.preventDefault();
    }
  }
}
